<template>

  <v-content>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="resetPasswordDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Reset Password</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Your password has been successfully changed.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="resetPasswordOkDialog" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout align-center justify-center>

      <v-card elevation="0" class="pb-2" min-width="400px" max-width="450">

        <v-card-title class="text-h5 word-break"><strong>Reset Password</strong></v-card-title>

        <v-card-text>

          <p>Please enter a new password:</p>

          <v-text-field label="Password" v-model="resetPasswordInfo.password" type="password" :error-messages="passwordErrors" maxlength="30" outlined></v-text-field>

          <v-text-field label="Confirm Password" v-model="resetPasswordInfo.confirmPassword" type="password" :error-messages="confirmPasswordErrors" maxlength="30" outlined></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="mr-2" @click="resetPassword">Reset Password</v-btn>

        </v-card-actions>

      </v-card>

    </v-layout>

  </v-content>

</template>

<script lang="ts">

import Vue from 'vue'

import {minLength, required} from "vuelidate/lib/validators";

import axios from "axios";

function validateMatchesPassword(value: any, data: { password: string | null; }) {

  return (value == data.password);

}

export default Vue.extend({

  name: 'ResetPassword',

  data: () =>
  {
    return {

      overlay: false,

      resetPasswordInfo: {

        token: null as string | null,

        password: '',

        confirmPassword: '',

      },

      resetPasswordDialog: false,

      errorSnackbar: false

    };
  },

  methods:
      {
        clearSnackbars() {

          this.errorSnackbar = false;

        },

        resetPassword()
        {
          this.$v.$touch();

          if (!this.$v.$invalid) {

            this.clearSnackbars();

            this.overlay = true;

            setTimeout(async () => {

              this.resetPasswordInfo.token = this.$route.query.token as string | null;

              let obj = await axios.post('accounts/reset-password', this.resetPasswordInfo);

              this.overlay = false

              this.resetPasswordDialog = true;

            }, 100);

          }
          else
          {

            this.errorSnackbar = true;

          }
        },

        resetPasswordOkDialog()
        {
          this.resetPasswordDialog = false;

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      },

  validations:
      {
        resetPasswordInfo: {

          password: {

            required,

            minLength: minLength(8)

          },

          confirmPassword: {

            required,

            minLength: minLength(8),

            validateMatchesPassword

          }

        }

      },

  computed:
      {
        passwordErrors()
        {
          if (this.$v.resetPasswordInfo.password && !this.$v.resetPasswordInfo.password.$dirty) return [];

          if (this.$v.resetPasswordInfo.password && !this.$v.resetPasswordInfo.password.required) return ['The Password is required.'];

          if (this.$v.resetPasswordInfo.password && !this.$v.resetPasswordInfo.password.minLength) return ['The Password must be at least 8 characters.'];

          return null;
        },

        confirmPasswordErrors()
        {
          if (this.$v.resetPasswordInfo.confirmPassword && !this.$v.resetPasswordInfo.confirmPassword.$dirty) return [];

          if (this.$v.resetPasswordInfo.confirmPassword && !this.$v.resetPasswordInfo.confirmPassword.required) return ['The Confirm Password is required.'];

          if (this.$v.resetPasswordInfo.confirmPassword && !this.$v.resetPasswordInfo.confirmPassword.minLength) return ['The Confirm Password must be at least 8 characters.'];

          if (this.$v.resetPasswordInfo.confirmPassword && !this.$v.resetPasswordInfo.confirmPassword.validateMatchesPassword) return ['The Confirm Password must match Password.'];

          return null;
        }

      }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

.v-messages__message {

  font-size: 14px !important;

}

th > .v-icon {

  color: white !important;

}

</style>
